import { NgModule } from '@angular/core';

import { IfBreakpointDirective } from './directives/if-breakpoint.directive';
import {
  KeyboardFocusBindingDirective
} from './directives/keyboard-focus-binding/keyboard-focus-binding.directive';

const directives = [
  KeyboardFocusBindingDirective,
  IfBreakpointDirective
];

@NgModule({
  declarations: [
    directives
  ],
  providers: [

  ],
  imports: [

  ],
  exports: [directives]
})
export class PacificwiseAngularSharedModule {

}
